export enum PostMessageKey {
    LocaleChanged = 'itero_everyone_language-changed',
    InitContext = 'itero_exocad-3d-viewer_init-context',
    GetContext = 'itero_shell_get-context',
    Error = 'itero_shell_handle-error',
    TokenExpired = 'itero_shell_token-expired',
    LoadingCompleted = 'itero_exocad-3d-viewer_loading-completed',
}
